export default __webpack_public_path__ + "static/media/wellness2.e1298891.jpeg";